<template>
  <div>
    <div class="card is-smallshadow">
      <div class="card-body py-3">
        <h2 class="heading-small text-grey mb-2">
          {{ $t('adviserSettings.workExperience') }}
        </h2>

        <div v-if="loadedExperiences">
          <div
            v-for="(experience, index) of allExperiences"
            :key="'experience-' + index"
            :class="{
              'flex flex-align-items-center items-list items-list-bigger': true,
              'mt-2 pb-2 full-width': true,
              'border-bottom': index < allExperiences.length - 1
            }">
            <div class="item-index pr-1">
              <strong>{{ index + 1 }}.</strong>
            </div>
            <div class="item-data mr-2">
              <small>{{ $t('adviserSettingsExperienceInfo.position') }} </small><br>
              <strong class="text-primary">{{ experience.position }}</strong>
            </div>
            <div class="item-data mr-2">
              <small>{{ $t('adviserSettingsExperienceInfo.employer') }} </small><br>
              <strong class="text-primary">{{ experience.employer }}</strong>
            </div>
            <div class="item-data mr-2">
              <small>{{ $t('adviserSettingsEducationInfo.timeStart') }} </small><br>
              <strong class="text-primary">{{ experience.start_at }}</strong>
            </div>
            <div class="item-data">
              <small>{{ $t('adviserSettingsEducationInfo.timeEnd') }} </small><br>
              <strong class="text-primary">
                <template v-if="experience.end_at">
                  {{ experience.end_at }}
                </template>
                <template v-else>
                  -
                </template>
              </strong>
            </div>
            <div
              class="item-options ml-2">
              <f-dropdown
                theme="minimal"
                type="more"
                :items="[
                  {
                    type: 'button',
                    disabled: false,
                    event: 'adviser-experience-edit',
                    param: experience,
                    label: $t('ui.edit'),
                    name: 'edit'
                  },
                  {
                    type: 'button',
                    disabled: false,
                    event: 'adviser-experience-remove',
                    param: experience,
                    label: $t('ui.remove'),
                    theme: 'danger',
                    name: 'delete'
                  }
                ]"/>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer pt-3 pb-4 text-right">
        <f-button
          v-if="loadedExperiences"
          theme="primary"
          big
          @click.prevent="$bus.$emit('adviser-experience-popup-show')">
          {{ $t('adviserSettingsEducationInfo.addEntry') }}
        </f-button>
      </div>
    </div>
    <div
      v-if="!loadedExperiences && !loadError"
      class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
    <f-alert
      v-if="loadError"
      visible
      theme="warning">
      <span>
        {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
      </span>
    </f-alert>

    <adviser-experience-popup />
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import ListUtils from '@/utils/ListUtils.js';
import AdviserExperiencePopup from '@/components/popups/AdviserExperiencePopup.vue';

export default {
  name: 'adviser-settings-experience-info',
  components: {
    'adviser-experience-popup': AdviserExperiencePopup
  },
  data() {
    return {
      allExperiences: [],
      loadedExperiences: false,
      removeInProgress: false,
      loadError: false
    }
  },
  mounted() {
    this.$bus.$on('adviser-experience-edit', this.editExperience);
    this.$bus.$on('adviser-experience-remove', this.removeExperience);
    this.$bus.$on('advisor-experience-reload', this.loadItemData);
    this.loadItemData();
  },
  methods: {
    loadItemData() {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/adviser/adviser/experiences/items',
        method: 'get',
        outputKey: 'allExperiences',
        loadedKey: 'loadedExperiences',
        errorKey: 'loadError',
      });
    },
    editExperience (experience) {
      this.$bus.$emit('adviser-experience-popup-show', experience);
    },
    removeExperience (experience) {
      if (experience.id) {
        this.removeInProgress = true;

        ListUtils.removeItem(this, {
          endpointBase: '/api/adviser/adviser/experiences/delete/',
          id: experience.id,
          successTitle: this.$t('adviserSettingsEducationInfo.entryRemove'),
          successText: this.$t('adviserSettingsEducationInfo.entryHasBeenRemove'),
          confirmTitle: this.$t('adviserSettingsEducationInfo.areYouSureRemove'),
          confirmText: this.$t('ui.thisOperationCannotUndone'),
          errorTitle: this.$t('ui.errorOccurred'),
          errorText: this.$t('adviserSettingsEducationInfo.entryRemoveError'),
          successAction: () => {
            this.removeInProgress = false;
            this.loadItemData();
          },
          cancelAction: () => {
            this.removeInProgress = false;
          }
        });
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('adviser-experience-edit', this.editExperience);
    this.$bus.$off('adviser-experience-remove', this.removeExperience);
    this.$bus.$off('advisor-experience-reload', this.loadItemData);
  }
}
</script>
